module.exports = __webpack_public_path__ + "img/logo-project-majorelle.8e64b2b9.png";